import { Component, Input } from '@angular/core';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';
import { ImmersionCarouselComponent } from '../immersion-carousel/immersion-carousel.component';
import { ImmersionCarouselService } from '../immersion-carousel/immersion-carousel.service';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';

@Component({
  selector: 'lp2-idiom-carousel',
  templateUrl: './idiom-carousel.component.html',
  styleUrls: ['./idiom-carousel.component.scss'],
})
export class IdiomCarouselComponent extends ImmersionCarouselComponent {
  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.idiomsPoints = value
      ? value.get(GamificationActivityType.COMPLETE_PRACTICE_COMMON_EXPRESSION)
      : 0;
  }

  idiomsPoints: number;

  public carouselSettings = DEFAULT_CAROUSEL_SETTINGS;

  constructor(
    public service: ImmersionCarouselService,
    public levelProgressService: LevelProgressService
  ) {
    super(service, levelProgressService, 'IDIOMS');
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/idiom-carousel/idiom-carousel.component.ts